"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { KpiDashboardMock } from "./mocks/KpiDashboardMock";
import { useI18n } from "@/lib/i18n/I18nProvider";
import { track, EVENTS } from "@/lib/analytics";

export function HeroVariantC() {
  const { t } = useI18n();
  return (
    <section className="relative bg-white pt-28 pb-0 overflow-hidden">
      {/* Subtle radial accent */}
      <div
        className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-keiro-mist/40 blur-3xl"
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Text — centered above mockup */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-keiro-green mb-4 px-3 py-1 bg-keiro-mist/60 rounded-full">
            {t("landing.hero.eyebrow")}
          </p>

          <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] font-bold text-keiro-obsidian leading-[1.15] tracking-tight mb-6">
            {t("landing.hero.headline")}{" "}
            <span className="block text-keiro-green">
              {t("landing.hero.headlineAccent")}
            </span>
          </h1>

          <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed mb-8">
            {t("landing.hero.subhead")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <a
              href="#demo"
              onClick={() =>
                track(EVENTS.ctaClick, {
                  section: "hero",
                  cta: "demo",
                  target: "#demo",
                })
              }
              className="inline-flex items-center gap-2 bg-keiro-green hover:bg-keiro-green-dark text-white px-7 py-3.5 text-base font-semibold rounded-lg transition-colors"
            >
              {t("landing.hero.ctaPrimary")}
              <ArrowRight className="w-4 h-4" />
            </a>
            <Link
              href="/login"
              onClick={() =>
                track(EVENTS.ctaClick, {
                  section: "hero",
                  cta: "login",
                  target: "/login",
                })
              }
              className="inline-flex items-center gap-2 border border-slate-300 text-slate-700 hover:bg-slate-50 px-7 py-3.5 text-base font-semibold rounded-lg transition-colors"
            >
              {t("landing.hero.ctaSecondary")}
            </Link>
          </div>

          <p className="text-sm text-slate-500">
            {t("landing.hero.trustLine")}
          </p>
        </div>

        {/* KPI Dashboard mockup — full width, prominent, THE visual */}
        <div className="relative mx-auto max-w-5xl">
          <div
            className="pointer-events-none absolute -inset-4 rounded-2xl bg-keiro-green/5 blur-2xl"
            aria-hidden
          />
          <div className="relative">
            <KpiDashboardMock />
          </div>
        </div>
      </div>

      {/* Fade to next section */}
      <div className="h-20 bg-gradient-to-b from-white to-slate-50/50" />
    </section>
  );
}
